<template>
  <div v-if="user">
    <div class="row">
      <div class="col-12">
        <a :href="`/users/${user.key}`">
          <avatar :user="user" />
          {{ user.name }}
        </a>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-12">
        🌏 {{ user.mag_count }} <span style="color: gray;">まぐわった</span>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="col-12">
        <chart :mags="user.mags_for_stats" :is-profile-page="false" />
      </div>
    </div>
  </div>
  <pr :show-timeline-button="true" v-else />
</template>

<script>
import Pr from './_pr'
import Chart from '../charts/_show'
import Avatar from './_avatar'

export default {
  components: { Pr, Chart, Avatar },
  props: ['user'],
  mounted() {
  },
  methods: {
  },
  computed: {
  }
}
</script>

<style scoped>
</style>
